<template>
  <el-menu :default-openeds="opens"
           style="height: 100%; overflow-x: hidden;"
           background-color="rgb(48, 65, 86)"
           text-color="#fff"
           active-color="#ffd04b"
           :collapsen="isCollapse"
           router
  >
    <div style="height: 60px; line-height: 60px; text-align: center">
      <img src="../assets/logo.png" alt="" style="width: 20px; position: relative; top: 4px; margin-right: 4px">
      <b style="color: white" v-show="logoTextShow">物业管理系统</b>
    </div>
    <!--    动态路由渲染 -->
    <!--    遍历menus，key是menuId -->
    <div v-for="item in menus" :key="item.id" class="aside-view">
      <!--      if该权限有 path，就是可以直接访问的，如主页 -->
      <div v-if="item.path">
        <el-menu-item :index="item.path">
          <i :class="item.icon"></i>
          <template slot="title">
            <span slot="title">{{ item.name }}</span>
          </template>
        </el-menu-item>
      </div>
      <!--      else没 path，那就是一些路由的集合名称，比如系统管理 -->
      <div v-else>
        <!--    没 path也不能空着 index，index接收的是字符串类型，这里拼接空字符串 -->
        <el-submenu :index="item.id + ''">
          <template slot="title">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.name }}</span>
          </template>
          <!--   子路由就遍历父路由的 children集合，用另一个变量名 subItem接收，key是 subItem的id -->
          <div v-for="subItem in item.children" :key="subItem.id">
            <el-menu-item :index="subItem.path">
              <i :class="subItem.icon"></i>{{ subItem.name }}
            </el-menu-item>
          </div>
        </el-submenu>

      </div>
    </div>
    <!--    <div>-->
    <!--      <el-submenu index="3">-->
    <!--        <template slot="title">-->
    <!--          <i class="el-icon-user-solid"></i>-->
    <!--          <span slot="title">员工管理</span>-->
    <!--        </template>-->
    <!--        <el-menu-item index="/emp">-->
    <!--          <i class="el-icon-user-solid"></i>员工信息-->
    <!--        </el-menu-item>-->
    <!--        <el-menu-item index="/dept">-->
    <!--          <i class="el-icon-user-solid"></i>部门管理-->
    <!--        </el-menu-item>-->
    <!--      </el-submenu>-->
    <!--      <el-submenu index="4">-->
    <!--        <template slot="title">-->
    <!--          <i class="el-icon-tickets"></i>-->
    <!--          <span slot="title">物品申购</span>-->
    <!--        </template>-->
    <!--        <el-menu-item index="/approvalGoodsInfo">-->
    <!--          <i class="el-icon-tickets"></i>申购单信息-->
    <!--        </el-menu-item>-->
    <!--        <el-menu-item index="/approvalGoodsTodo">-->
    <!--          <i class="el-icon-tickets"></i>代办申购单-->
    <!--        </el-menu-item>-->
    <!--      </el-submenu>-->
    <!--        <el-menu-item index="/receipt">-->
    <!--          <i class="el-icon-document"></i>收据管理-->
    <!--        </el-menu-item>-->
    <!--    </div>-->
    <!--    <el-menu-item index="/">-->
    <!--      <i class="el-icon-s-home"></i>-->
    <!--      <template slot="title">-->
    <!--        <span slot="title">主页</span>-->
    <!--      </template>-->
    <!--    </el-menu-item>-->
    <!--    <el-submenu index="3">-->
    <!--      <template slot="title">-->
    <!--        <i class="el-icon-setting"></i>-->
    <!--        <span slot="title">系统管理</span>-->
    <!--      </template>-->
    <!--        <el-menu-item index="/user">-->
    <!--          <i class="el-icon-user-solid"></i>用户管理-->
    <!--        </el-menu-item>-->
    <!--      <el-menu-item index="/role">-->
    <!--        <i class="el-icon-s-custom"></i>角色管理-->
    <!--      </el-menu-item>-->
    <!--      <el-menu-item index="/menu">-->
    <!--        <i class="el-icon-unlock"></i>权限管理-->
    <!--      </el-menu-item>-->
    <!--    </el-submenu>-->
  </el-menu>
</template>

<script>
export default {
  name: "Aside",
  props: {
    // 是否水平展开
    isCollapse: Boolean,
    logoTextShow: Boolean,
  },
  data() {
    return {
      // 当前登录的角色的权限集合
      menus: localStorage.getItem("menus") ? JSON.parse(localStorage.getItem("menus")) : [],
      // 默认垂直展开的权限导航条，只有是id的才是权限集合，其他本来就是展开的
      // opens: localStorage.getItem("menus") ? JSON.parse(localStorage.getItem("menus")).map(v => v.id + '') : []
      // opens: ['16'], // 默认展开的是审批流程
      opens: [],

    }
  },
  methods: {

  }
}
</script>

<style scoped>
  /* 创建自定义滚动条 */
  ::-webkit-scrollbar {
      width: 1px;
      height: 1px;
  }

  /* 定义轨道 */
  ::-webkit-scrollbar-track {
      background: #eee;
      border-radius: 4px;
  }

  /* 定义滑块 */
  ::-webkit-scrollbar-thumb {
      background: #999;
  }

  /* 使用伪元素添加装饰 */
  ::-webkit-scrollbar-thumb::before {
      content: "";
      display: block;
      position: absolute;
      top: 2px;
      left: 2px;
      right: 2px;
      bottom: 2px;
      background: #fff;
      border-radius: 4px;
  }
</style>
